export const eventCategories = {
  selectPaymentMethod: 'SelectPaymentMethod',
  checkout: 'Checkout',
  cart: 'Cart',
}
